import { apiFetch } from '@/platform/lib/api';

export type CurvePoint = {
  stoneCarats: number;
  referencePiecePriceUsd: number;
  rawSampleCount: number;
  trimmedSampleCount?: number;
};

export type CommunityMaterialPrice = {
  materialId: string;
  referencePriceUsd: number;
  valuationUnit: string;
  pricingMode?: 'linear' | 'piece_curve';
  points?: CurvePoint[];
  rawSampleCount: number;
  trimmedSampleCount?: number;
  totalSampleWeight?: number;
  rawMedianUsd?: number;
  updatedAt?: string;
};

export type SpotMaterialPrice = {
  materialId: string;
  priceKey: string;
  pricePerUnitUsd: number;
  valuationUnit: string;
  fredSeriesId?: string;
  source?: string;
  indexValue?: number;
  fetchedAt?: string;
};

export type MaterialInfoLink = {
  id: string;
  materialId: string;
  title: string;
  url: string;
  description?: string;
  kind: string;
  sortOrder: number;
  active: boolean;
};

export type MaterialBlogLink = {
  id: string;
  materialId: string;
  title: string;
  url: string;
  description?: string;
  status: 'pending' | 'approved' | 'rejected';
  rejectReason?: string;
};

export function getMaterialCommunityPrice(materialId: string) {
  return apiFetch<CommunityMaterialPrice>(`/materials/${materialId}/community-price`);
}

export function getMaterialSpotPrice(materialId: string) {
  return apiFetch<SpotMaterialPrice>(`/materials/${materialId}/spot-price`);
}

export function submitMaterialPrice(
  materialId: string,
  body: { stoneCarats?: number; piecePriceUsd?: number; pricePerGramUsd?: number; comment?: string },
) {
  return apiFetch<CommunityMaterialPrice>(`/materials/${materialId}/price-submission`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function listMaterialInfoLinks(materialId: string) {
  return apiFetch<{ links: MaterialInfoLink[] }>(`/materials/${materialId}/info-links`);
}

export function listMaterialBlogLinks(materialId: string) {
  return apiFetch<{ links: MaterialBlogLink[] }>(`/materials/${materialId}/blog-links`);
}

export function getMyMaterialBlogLink(materialId: string) {
  return apiFetch<{ link: MaterialBlogLink | null }>(`/materials/${materialId}/blog-links/mine`);
}

export function submitMaterialBlogLink(materialId: string, body: { url: string; title: string; description?: string }) {
  return apiFetch<{ link: MaterialBlogLink }>(`/materials/${materialId}/blog-links`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export type MaterialCatalogItem = {
  materialId: string;
  displayName: string;
  kind: string;
  haulCategory?: string;
  gemTier?: string;
  scientificName?: string;
  imageUrl?: string;
  valuationMethod: string;
  weightUnit: string;
  weightEntryMode?: string;
  synonymTokens?: string[];
};

export function listMaterials(q?: string) {
  const qs = q ? `?q=${encodeURIComponent(q)}` : '';
  return apiFetch<{ materials: MaterialCatalogItem[] }>(`/materials${qs}`);
}
